(() => {
  const root = document.querySelector('[data-sc-search]');
  if (!root) return;

  const input = root.querySelector('[data-sc-search-input]');
  const heading = root.querySelector('[data-sc-search-heading]');
  const popular = root.querySelector('[data-sc-search-popular]');
  const results = root.querySelector('[data-sc-search-results]');
  const empty = root.querySelector('[data-sc-search-empty]');
  const more = root.querySelector('[data-sc-search-more]');
  const moreLabel = root.querySelector('[data-sc-search-more-label]');
  const clearBtn = root.querySelector('[data-sc-search-clear]');
  const openers = document.querySelectorAll('[data-sc-search-open]');
  const closers = root.querySelectorAll('[data-sc-search-close]');
  const copyNode = document.querySelector('[data-sc-search-copy]');
  const catalogNode = document.querySelector('[data-sc-search-catalog]');
  let copy = {};
  let catalog = [];
  try {
    copy = JSON.parse(copyNode?.textContent || '{}');
  } catch (e) {
    copy = {};
  }
  try {
    catalog = JSON.parse(catalogNode?.textContent || '[]');
  } catch (e) {
    catalog = [];
  }
  if (!Array.isArray(catalog)) catalog = [];
  const searchUrl = root.getAttribute('data-search-url') || '/search';
  const moneyFormat = root.getAttribute('data-money-format') || '{{amount}}';
  const CART_ICON =
    '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" fill="none" aria-hidden="true"><path d="M12.5962 7.05V4.35C12.5962 2.36178 10.9845 0.75 8.99623 0.75C7.00801 0.75 5.39623 2.36178 5.39623 4.35V7.05M1.42903 8.26677L0.889034 14.0268C0.735496 15.6645 0.658728 16.4834 0.930476 17.1158C1.1692 17.6715 1.58754 18.1309 2.11845 18.4204C2.7228 18.75 3.54526 18.75 5.19017 18.75H12.8023C14.4472 18.75 15.2697 18.75 15.874 18.4204C16.4049 18.1309 16.8233 17.6715 17.062 17.1158C17.3337 16.4834 17.257 15.6645 17.1034 14.0268L16.5634 8.26677C16.4338 6.88381 16.3689 6.19233 16.0579 5.66955C15.784 5.20913 15.3793 4.8406 14.8954 4.61086C14.3458 4.35 13.6513 4.35 12.2623 4.35L5.73017 4.35C4.34115 4.35 3.64664 4.35 3.09711 4.61086C2.61313 4.8406 2.20844 5.20913 1.93453 5.66955C1.62351 6.19233 1.55869 6.88381 1.42903 8.26677Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  let lastOpener = null;
  let timer = 0;

  const formatMoney = (cents) => {
    if (cents == null || cents === '') return '';
    const amount = (Number(cents) / 100).toFixed(2);
    if (!Number.isFinite(Number(amount))) return '';
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(Number(amount) || 0)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','));
  };

  const productImage = (product) => {
    if (!product) return '';
    if (typeof product.image === 'string') return product.image;
    const image = product.featured_image || product.image;
    if (!image) return '';
    if (typeof image === 'string') return image;
    return image.url || image.src || '';
  };

  const productPrice = (product) => formatMoney(product.price);

  const comparePrice = (product) => {
    const compare = Number(product.compareAt || product.compare_at_price || 0);
    const price = Number(product.price || 0);
    if (!compare || compare <= price) return '';
    return formatMoney(compare);
  };

  const variantId = (product) => product.variantId || product.variants?.[0]?.id || '';

  const escapeHtml = (value) =>
    String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');

  const renderCard = (product) => {
    const title = escapeHtml(product.title);
    const url = product.url || '#';
    const image = productImage(product);
    const price = productPrice(product);
    const compare = comparePrice(product);
    const vid = variantId(product);
    const atcAttrs = vid ? ` data-sc-atc-card data-variant-id="${vid}"` : '';
    const cart = vid
      ? `<button type="button" class="sc-shop__cart" aria-label="Add ${title} to cart">${CART_ICON}</button>`
      : `<span class="sc-shop__cart" aria-hidden="true">${CART_ICON}</span>`;

    return `
      <article class="sc-shop__card sc-shop__card--atc"${atcAttrs}>
        <a class="sc-shop__stretch" href="${escapeHtml(url)}" aria-label="${title}"></a>
        <div class="sc-shop__card-top">
          <span class="sc-shop__badge sc-shop__badge--spacer" aria-hidden="true"></span>
          ${cart}
        </div>
        <div class="sc-shop__media">
          ${
            image
              ? `<img class="sc-shop__image" src="${escapeHtml(image)}" alt="${title}" loading="lazy" width="280" height="280">`
              : `<div class="sc-shop__image-placeholder" aria-hidden="true"></div>`
          }
        </div>
        <div class="sc-shop__info">
          <div class="sc-shop__title-row">
            <h3 class="sc-shop__title">${title}</h3>
            ${
              price
                ? `<p class="sc-shop__price"><span>${escapeHtml(price)}</span>${
                    compare ? `<s class="sc-shop__compare">${escapeHtml(compare)}</s>` : ''
                  }</p>`
                : ''
            }
          </div>
        </div>
      </article>
    `;
  };

  const setSearching = (query) => {
    const q = (query || '').trim();
    if (clearBtn) clearBtn.hidden = !q;
    if (!more) return;
    if (!q) {
      more.hidden = true;
      return;
    }
    more.hidden = false;
    more.href = `${searchUrl}?q=${encodeURIComponent(q)}&type=product`;
    const template = copy.more || 'Search for “%q”';
    if (moreLabel) moreLabel.textContent = template.replace('%q', q.toUpperCase());
  };

  const showPopular = () => {
    heading.textContent = copy.popular || 'Popular products';
    popular.hidden = false;
    results.hidden = true;
    results.innerHTML = '';
    empty.hidden = true;
    setSearching('');
  };

  const showResults = (products) => {
    heading.textContent = copy.results || 'Products';
    popular.hidden = true;
    if (!products.length) {
      results.hidden = true;
      results.innerHTML = '';
      empty.hidden = false;
      return;
    }
    empty.hidden = true;
    results.hidden = false;
    results.innerHTML = products.map(renderCard).join('');
  };

  const matchesQuery = (product, query) => {
    const haystack = [product.title, product.type, product.vendor]
      .concat(product.tags || [])
      .join(' ')
      .toLowerCase();
    return haystack.indexOf(query) !== -1;
  };

  const search = (query) => {
    const q = query.trim().toLowerCase();
    if (!q) {
      showPopular();
      return;
    }

    heading.textContent = copy.results || 'Products';
    popular.hidden = true;
    setSearching(query.trim());
    showResults(catalog.filter((product) => matchesQuery(product, q)).slice(0, 8));
  };

  const open = (opener) => {
    lastOpener = opener || null;
    const menuToggle = document.querySelector('[data-sc-header-toggle]');
    if (menuToggle && menuToggle.getAttribute('aria-expanded') === 'true') {
      menuToggle.click();
    }
    root.hidden = false;
    root.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    window.setTimeout(() => input?.focus(), 20);
  };

  const close = () => {
    root.classList.remove('is-open');
    root.hidden = true;
    document.body.style.overflow = '';
    if (input) input.value = '';
    showPopular();
    if (lastOpener && typeof lastOpener.focus === 'function') lastOpener.focus();
  };

  openers.forEach((btn) => {
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      open(btn);
    });
  });

  closers.forEach((btn) => {
    btn.addEventListener('click', () => close());
  });

  clearBtn?.addEventListener('click', () => {
    if (!input) return;
    input.value = '';
    input.focus();
    showPopular();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && root.classList.contains('is-open')) {
      event.preventDefault();
      close();
    }
  });

  input?.addEventListener('input', () => {
    const q = input.value;
    const trimmed = q.trim();
    setSearching(trimmed);
    if (trimmed) {
      heading.textContent = copy.results || 'Products';
      popular.hidden = true;
    }
    window.clearTimeout(timer);
    timer = window.setTimeout(() => search(q), 180);
  });
})();
